import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { CYCLE, firstDelayAt, PHASE_SALVE } from '../bosses/navette.cycle';
import { defineEnemy, Motion, Pattern } from '../schema';

/** B02-a — PEIGNE DE LA NAVETTE. Partie destructible, montée par paire (±180 u).
 *
 *  ── Rôle : la sanction du bord ──
 *  3 000 PV, la partie chère, et la seule menace VISÉE du combat. Elle tire une
 *  unique salve par cycle, à l'ancrage — c'est-à-dire au moment où le porteur
 *  vient de s'immobiliser contre un bord.
 *
 *  Toute la leçon du boss tient dans ce couple de timing et de position. Un
 *  joueur qui a suivi la traversée est contre le même bord que le peigne quand
 *  la salve part : elle le prend de face, à courte distance, sans espace pour
 *  s'écarter. Un joueur qui a croisé à contresens la reçoit de loin et en
 *  diagonale, ce qui la rend triviale.
 *
 *  Le peigne n'est donc pas « l'arme forte du boss » : c'est le dispositif qui
 *  mesure si le joueur a compris qu'il fallait cesser de suivre.
 *
 *  ── Trois projectiles et pas davantage ──
 *  L'éventail visé est étroit (18°) et court en nombre. Une salve dense
 *  deviendrait insurvivable au contact du bord, ce qui transformerait une leçon
 *  en punition sèche : le joueur mourrait avant d'avoir eu le temps d'observer
 *  ce qui l'a tué, et n'aurait donc aucun moyen d'apprendre. Trois projectiles
 *  laissent toujours un passage, y compris dans le pire cas — c'est cher payé
 *  mais jamais fatal. */
export default defineEnemy({
  id: 'navette-peigne',
  // Standard et non Heavy malgré 3 000 PV : le rang ne mesure pas la
  // résistance, il dose le gel et la secousse à la mort (PLAN.md §6.2).
  rank: Rank.Standard,
  hp: 3000,
  visualRadius: 30,
  score: 2600,
  telegraph: 2.2,
  drops: 3,
  motion: { kind: Motion.Hover, speed: 0, amplitude: 0, frequency: 0, holdY: 345 },
  emitter: {
    pattern: Pattern.Aimed,
    every: CYCLE,
    count: 3,
    spreadDeg: 18,
    speed: 470,
    firstDelay: firstDelayAt(PHASE_SALVE),
    family: Fam.EnemyPink,
  },
});
